import React, { useEffect, useState, useRef } from 'react';
import { Button, message, MessageBox, Row, Col, Tooltip } from 'kenshin';
import TablePro from '@/components/TablePro';
import { connect, history } from 'umi';
import ModalFormPro from '@/components/ModalFormPro';
import TreeData from '../../../../taskManage/components/TreeData';
import ServiceCategoryModal from '../../../../taskManage/components/ServiceCategoryModal';
import { menberListOptions } from '../../../detailDataTransform';
import { findTree } from '@/components/ServCategoryList';
import { exportTaskList, getTaskTagList } from '@/_serveice/project';
import { downloadXlsx, splitParamsFoGet } from '@/_util/util';
import {
  getCloumns,
  statusFormItem,
  getEdtaFormItem,
  getSearchCloumns,
} from '../../../../taskManage/cloumnsData';

const toOptions = (arr = []) => {
  arr ||= [];
  return arr.map((item) => ({
    value: item.proServCatgId,
    title: item.servCatgName,
    children: toOptions(item.childList),
    data: item,
  }));
};

const RptInfo = ({ project, systemOrgani, dispatch }) => {
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [editModalData, setEditModalData] = useState(null);
  const [employeeAll, setEmployeeAll] = useState([]);
  const [leaderKey, setLeaderKey] = useState('');

  const [selectKey, setSelectKey] = useState([]);
  const [servCatgList, setServCatgList] = useState({});
  const [tagList, setTagList] = useState([]);
  const [currentCheckedKeys, setCurrentCheckedKeys] = useState([]);
  const [serviceCategoryModalVisible, setServiceCategoryModalVisible] =
    useState(false);

  /** 存储当前服务类目对应的数据 */
  const [statusVisible, setStatusVisible] = useState(false);
  const [statusData, setStatusData] = useState([]);

  /** 存储当前服务类目对应的数据 */
  const curData = useRef({ projectId: history.location.query?.projectId });

  useEffect(() => {
    // dispatch({
    //   type: 'project/getSimpProjectList',
    // });
    // 组织架构
    dispatch({
      type: 'systemOrgani/getAllEmployee',
    }).then((res) => {
      setEmployeeAll(res);
    });
    // 服务类目
    // dispatch({
    //   type: 'project/getServcatgEasyList',
    // });
    return () => {
      dispatch({
        type: 'project/save',
        payload: {
          taskList: {},
          taskListSearchForm: {},
        },
      });
    };
  }, []);

  /** 根据项目id获取服务类目 */
  const getServcatgForProjectId = (projectId) => {
    if (servCatgList[projectId]) {
      return servCatgList[projectId];
    }
    dispatch({
      type: 'project/getProServcatgTree',
      payload: {
        projectId,
      },
    }).then((data) => {
      setServCatgList((list) => {
        list[projectId] = toOptions(data);
        return { ...list };
      });
    });
  };

  const setTaskTagList = (poServCatgId) => {
    if (!poServCatgId) {
      return;
    }
    getTaskTagList({ type: 2, poServCatgId: +poServCatgId }).then((res) => {
      if (res?.data) {
        if (tagList.length == 0) {
          // 保底，防止数据显示id
          setTagList(
            res.data.map((item) => ({ label: item.value, value: item.id })),
          );
        }
        const { form } = modalRef.current;
        form.setFieldsValue({
          taskTagList: res?.data.map((item) => item.id) || [],
        });
      }
    });
  };

  /** 一些从服务类目树带过来的默认数据 */
  const editShowData = (row) => {
    const {
      servCatgName,
      servCatgLeader,
      servCatgBeginTime,
      servCatgEndTime,
      servCatgWorkPeriod: taskWorkPeriod,
      proServCatgId,
    } = curData.current || {};

    let dbServCatgTeamMemberList =
      row.dbTaskTeamMemberList || curData.current?.dbServCatgTeamMemberList;
    let defaultValue = {
      proServCatgId,
      servCatgName,
      addTeamMemberList: dbServCatgTeamMemberList?.map(
        (member) => findTree(employeeAll, member.teamMemberId)?.value,
      ),
      taskTime: [
        moment(row.taskBeginTime || servCatgBeginTime || undefined),
        moment(row.taskEndTime || servCatgEndTime || undefined),
      ],
      taskWorkPeriod,
      ...row,
      taskLeader: findTree(employeeAll, row.taskLeader || servCatgLeader)
        ?.value,
    };
    return defaultValue;
  };

  /** 打开新增编辑框 */
  const showEditModal = (row = {}) => {
    setEditModalVisible(true);
    let data = { ...editShowData(row) };
    let projectId = data?.projectId || history.location.query?.projectId;
    if (projectId) {
      getServcatgForProjectId(projectId);
    }

    // 回显标签中文
    if (data.taskTagList && Array.isArray(data.taskTagList)) {
      if (typeof data.taskTagList[0] === 'object') {
        const currentTags = data.taskTagList.map((t) => ({
          label: t.value,
          value: t.id,
        }));
        setTagList(currentTags);
        data.taskTagList = data.taskTagList.map((t) => t.id);
      }
    }

    setLeaderKey(data.taskLeader);
    setEditModalData(data);
  };

  /** 删除 */
  const delRole = (payload) => {
    MessageBox.confirm({
      title: '确认操作',
      content: '确认删除？删除后无法恢复',
      onOk: () => {
        dispatch({
          type: 'project/deleteTask',
          payload,
        }).then((res) => {
          if (res) {
            message.success('删除成功');
          }
        });
      },
    });
  };

  /** 修改状态点击确定 */
  const statusSave = (val) => {
    let taskStatus = {
      taskIdList: statusData,
      taskStatus: val.taskStatus,
    };
    dispatch({
      type: 'project/taskStatus',
      payload: taskStatus,
    }).then((res) => {
      if (res) {
        setStatusVisible(false);
        setStatusData(null);
      }
    });
  };

  const addType = (item, payload) => {
    return {
      ...item,
      type: payload.taskLeader == item.teamMemberId ? 1 : 0,
    };
  };

  const editModalSave = ({ servCatgId, ...value }) => {
    if (!value.proServCatgId) {
      message.error('上级类目不能为空');
      return;
    }
    if (!value.addTeamMemberList?.includes(value.taskLeader)) {
      message.error('参与人员必须含有负责人！');
      return;
    }
    let payload = {
      proServCatgId: curData.current?.proServCatgId,
      projectId: history.location.query?.projectId || editModalData.projectId,
      taskTeamMemberNum: value.addTeamMemberList.length,
      oldTaskTeamMemberList: [],
      removeTaskTeamMemberList: [],
      ...value,
      taskLeader: value?.taskLeader.split('-')[1],
    };
    if (payload.taskTagList) {
      payload.taskTagList = payload.taskTagList.map((id) => ({ id }));
    }
    if (payload.taskTime) {
      const [start, end] = payload.taskTime;
      payload.taskBeginTime = moment(start).format('YYYY-MM-DD HH:mm:ss');
      payload.taskEndTime = moment(end).format('YYYY-MM-DD HH:mm:ss');
    }
    payload.taskTime = undefined;
    let hasEdit = false;
    if (editModalData.taskId) {
      // 编辑
      hasEdit = true;
      let memberList = menberListOptions({
        dbServCatgTeamMemberList: editModalData.dbTaskTeamMemberList,
        addTeamMemberList: value.addTeamMemberList,
      });
      payload.oldTaskTeamMemberList =
        memberList.thisOldServCatgTeamMemberList.map((item) =>
          addType(item, payload),
        );
      payload.removeTaskTeamMemberList =
        memberList.thisRemoveServCatgTeamMemberList;
      payload.addTaskTeamMemberList =
        memberList.thisNewAddServCatgTeamMemberList.map((item) =>
          addType(item, payload),
        );
      payload.taskId = editModalData.taskId;
    }
    if (!hasEdit && payload.addTeamMemberList) {
      payload.addTaskTeamMemberList = payload.addTeamMemberList?.map(
        (item, index) => ({
          teamMemberId: item.split('-')[1],
          teamMemberSort: index + 1,
          type: payload.taskLeader == item.split('-')[1] ? 1 : 0,
        }),
      );
    }
    payload.addTeamMemberList = undefined;
    payload.servCatgName = undefined;
    // menberListOptions()
    dispatch({
      type: 'project/addTask',
      hasEdit,
      payload,
    }).then((res) => {
      if (res) {
        setEditModalData(null);
        setEditModalVisible(false);
        message.success('操作成功');
      }
    });
  };

  const finishTask = (payload) => {
    MessageBox.confirm({
      title: '确认操作',
      content: '确认已经完成？请检查后再确认。',
      onOk: () => {
        dispatch({
          type: 'project/finishTask',
          payload,
        }).then((res) => {
          if (res) {
            message.success('操作成功');
          }
        });
      },
    });
  };

  const columns = getCloumns({
    employeeAll,
    setStatusVisible,
    setStatusData,
    showEditModal,
    delRole,
    isButton: true,
  });

  const leaderChange = (keys) => {
    const { form } = modalRef.current;
    let oldArr = form.getFieldsValue()?.addTeamMemberList || [];
    setLeaderKey(keys);
    oldArr.push(keys);
    oldArr = Array.from(new Set(oldArr));
    form.setFieldsValue({
      addTeamMemberList: oldArr,
    });
  };
  const modalRef = useRef({});

  // 弹窗formItem
  const edtaFormItem = getEdtaFormItem({
    servCatgList,
    editModalData,
    curData,
    employeeAll,
    modalRef,
    leaderChange,
    leaderKey,
    tagList,
    setTaskTagList,
    onShowServiceCategoryModal: (keys) => {
      setCurrentCheckedKeys(keys || []);
      setServiceCategoryModalVisible(true);
    },
  });
  const handleServiceCategorySelect = (tags) => {
    if (tags) {
      const newTagList = tags.map((item) => ({
        label: item.value,
        value: item.id,
      }));
      setTagList(newTagList);
      modalRef.current?.form?.setFieldsValue({
        taskTagList: newTagList.map((t) => t.value),
      });
    }
  };

  const treeHandleChange = (keys, row) => {
    curData.current = { ...curData.current, ...row };
    console.log(row);
    tableRef.current?.reload(
      {
        projectId: history.location.query?.projectId,
        proServCatgId: row?.proServCatgId,
      },
      true,
    );
  };

  const searchCloumns = getSearchCloumns({
    employeeAll,
  });

  let tableRef = useRef();

  /** 批量完成 */
  const batchClose = () => {
    if (selectKey?.length == 0) {
      message.warn('请选择需要完成的任务');
      return;
    }
    // finishTask({ taskIdList: selectKey });
    setStatusData(selectKey);
    setStatusVisible(true);
  };

  const extra = () => [
    <Button type="primary" key={btnKeys.add} onClick={() => showEditModal()}>
      新增任务
    </Button>,
    <Button type="primary" key={btnKeys.statusChange} onClick={batchClose}>
      批量修改状态
    </Button>,
    <Button
      type="primary"
      key="noKeys"
      onClick={() => {
        let { taskTime, ...value } = tableRef.current.value;
        let payload = {
          memberList: value.memberList ?? [],
          proServCatgId: value.proServCatgId ?? '',
          projectId: history.location.query?.projectId ?? '',
          taskName: value.taskName ?? '',
          taskBeginTime: '',
          taskEndTime: '',
        };
        if (payload.memberList) {
          payload.memberList = payload.memberList.map(
            (item) => item.split('-')[1],
          );
        }
        if (taskTime) {
          payload.taskBeginTime = moment(taskTime[0])
            .startOf('d')
            .format('YYYY-MM-DD HH:mm:ss');
          payload.taskEndTime = moment(taskTime[1])
            .endOf('d')
            .format('YYYY-MM-DD HH:mm:ss');
        }
        let url = `${baseURL}${exportTaskList}${splitParamsFoGet(payload)}`;
        downloadXlsx(url, '任务列表');
      }}
    >
      导出
    </Button>,
  ];

  const onSubmit = (payload) => {
    payload.projectId = history.location.query?.projectId;
    // if (!payload.projectId) {
    //   return false;
    // }
    // if (employeeAll?.length == 0) {
    //   return false;
    // }
    if (payload.taskTime) {
      const [start, end] = payload.taskTime;
      payload.taskBeginTime = moment(start)
        .startOf('d')
        .format('YYYY-MM-DD HH:mm:ss');
      payload.taskEndTime = moment(end)
        .endOf('d')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    payload.taskTime = undefined;
    if (payload.memberList) {
      payload.memberList = payload.memberList.map((item) => item.split('-')[1]);
    }
  };

  const rowSelection = {
    selectedRowKeys: selectKey,
    onChange: (userIdList) => {
      setSelectKey(userIdList);
    },
    // getCheckboxProps: (record) => ({
    //   disabled: record.taskStatus == 1, // Column configuration not to be checked
    // }),
  };

  return (
    <div>
      <Row gutter="20" style={{ height: '100%' }}>
        <Col span={4}>
          <TreeData
            projectId={history.location.query?.projectId}
            hideProjectSelect={true}
            onChange={treeHandleChange}
          />
        </Col>
        <Col span={16}>
          <TablePro
            params={{
              projectId: history.location.query?.projectId,
              proServCatgId: curData.current?.proServCatgId,
            }}
            request="project/getTaskPage"
            rowKey="taskId"
            columns={columns}
            extra={extra}
            searchCloumns={searchCloumns}
            curColumns
            data={project.taskList}
            columnsOptions={false}
            scrollX
            actionRef={(ref) => (tableRef.current = ref)}
            onSubmit={onSubmit}
            childrenColumnName="child"
            rowSelection={{
              type: 'checkbox',
              ...rowSelection,
            }}
          />
        </Col>
      </Row>

      <ModalFormPro
        width={'80%'}
        title={editModalData?.taskId ? '编辑' : '新增'}
        formProps={{
          layout: 'vertical',
          labelCol: { span: 8 },
          wrapperCol: { span: 12 },
          className: 'inline-form',
          initialValues: {
            servCatgHourOrginCost: 1800,
          },
        }}
        visible={editModalVisible}
        edtaFormItem={edtaFormItem}
        formData={editModalData}
        onSave={editModalSave}
        ref={modalRef}
        onCancel={() => {
          setEditModalData(null);
          setEditModalVisible(false);
          setTagList([]);
        }}
      />

      <ModalFormPro
        title={'修改状态'}
        visible={statusVisible}
        edtaFormItem={statusFormItem}
        onSave={statusSave}
        onCancel={() => {
          setStatusData([]);
          setStatusVisible(false);
        }}
      />
      <ServiceCategoryModal
        visible={serviceCategoryModalVisible}
        onCancel={() => setServiceCategoryModalVisible(false)}
        onOk={handleServiceCategorySelect}
        checkedKeys={currentCheckedKeys}
      />
    </div>
  );
};

export default connect(({ project, systemOrgani }) => {
  return {
    project,
    systemOrgani,
  };
})(RptInfo);
